import Button from "./Button";
import { icons } from "./icons";

export default function CopyToClipBoard({ text, className }) {
	return (
		<div className="absolute right-0 top-0 z-50 m-3">
			<Button
				onClick={() => {
					navigator.clipboard.writeText(text);
				}}
				className={
					"right-0 top-0 bg-dark-200 p-0 px-2 text-dark-500 hover:bg-accent-500 hover:text-accent-100 " +
					className
				}
			>
				{icons.copy}
				Copy
			</Button>
		</div>
	);
}
